module.exports = __webpack_public_path__ + "img/art3-img3.17727364.jpeg";